import React from 'react'
import PropTypes from 'prop-types'

const Types = ({ selectedType, onTypeChange, aggregates }) => {
  const className = (value) => {
    return `section__item ${(selectedType === value ? ' is-active' : '')}`
  }

  return (
    <div className="conversations-sidebar__section">
      <div className={className('')} onClick={onTypeChange} value="">
        All conversations ({aggregates.all || 0})
      </div>
      <div className={className('personal')} onClick={onTypeChange} value="personal">
        Regular ({aggregates.personal || 0})
      </div>
      <div className={className('jobApplication')} onClick={onTypeChange} value="job_application">
        3D Projects ({aggregates.jobApplication || 0})
      </div>
      <div className={className('modelFeedback')} onClick={onTypeChange} value="model_feedback">
        Product Feedback ({aggregates.modelFeedback || 0})
      </div>
      <div className={className('offer')} onClick={onTypeChange} value="offer">
        Price Offers ({aggregates.offer || 0})
      </div>
      <div className={className('modelSupport')} onClick={onTypeChange} value="model_support">
        Model Support ({aggregates.modelSupport || 0})
      </div>
      <div className={className('cgtraderSupport')} onClick={onTypeChange} value="cgtrader_support">
        CGTrader Support ({aggregates.cgtraderSupport || 0})
      </div>
      <div className={className('fileConversionRequest')} onClick={onTypeChange} value="file_conversion_request">
        File conversion requests ({aggregates.fileConversionRequest || 0})
      </div>
      <div className={className('promotions')} onClick={onTypeChange} value="promotions">
        Promotions ({aggregates.promotions || 0})
      </div>
    </div>
  )
}

Types.propTypes = {
  aggregates: PropTypes.shape({
    all: PropTypes.number,
    personal: PropTypes.number,
    cgtraderSupport: PropTypes.number,
    modelSupport: PropTypes.number,
    offer: PropTypes.number,
    jobApplication: PropTypes.number,
    modelFeedback: PropTypes.number,
    fileConversionRequest: PropTypes.number,
  }).isRequired,
  onTypeChange: PropTypes.func.isRequired,
  selectedType: PropTypes.string,
}

Types.defaultPropTypes = {
  selectedType: '',
}

export default Types
